function _getDrawParams(image) {
  let { width, height } = image;
  let sx;
  let sy;

  if (image.width > image.height) {
    sx = (width - height) / 2;
    sy = 0;
  } else {
    sx = 0;
    sy = (height - width) / 2;
  }

  return { sx, sy };
}

const acceptedFileTypes = 'image/bmp,image/jpeg,image/png,image/gif';

const cropImage = function (image, maxImageSize) {
  let { width, height } = image;
  let canvas = document.createElement('canvas');
  let context = canvas.getContext('2d');

  let sqSize = Math.min(width, height);
  let cropSize = maxImageSize ? Math.min(sqSize, maxImageSize) : sqSize;

  canvas.width = cropSize;
  canvas.height = canvas.width;

  let { sx, sy } = _getDrawParams(image);

  context.drawImage(image, sx, sy, sqSize, sqSize, 0, 0, cropSize, cropSize);

  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob));
  });
};

const getImageFromDataUrl = function (dataUrl) {
  return new Promise((resolve) => {
    let image = new Image();

    image.onload = function () {
      resolve(image);
    };

    image.src = dataUrl;
  });
};

export { acceptedFileTypes, cropImage, getImageFromDataUrl };
